<div class="d-flex justify-content-center">
    <div class="btn-group btn-group" role="group">
        <input type="radio" class="btn-check" name="btnradio" id="btnradio1" autocomplete="off" [(ngModel)]="Filter"
            value="production">
        <label class="btn btn-outline-danger" for="btnradio1">PRODUCTION</label>
        <input type="radio" class="btn-check" name="btnradio" id="btnradio3" value="test" autocomplete="off"
            [(ngModel)]="Filter">
        <label class="btn btn-outline-success" for="btnradio3">TEST</label>
    </div>
</div>

<hr>
<div class="row g-3 text-center" style="height:80px">
    <h2>
        LDS applications available to you:
    </h2>
</div>
<div class="row g-3 justify-content-around">
    <div class="col-sm-3" *ngFor="let app of Filter == 'production' ? Production_Applications : Test_Applications">
        <div class="card text-center">
            <div class="card-body">
                <h3 class="card-title">
                    {{ app.ApplicationName }}
                </h3>
                <!-- <i class={{app.Icon}} style="font-size: 50px;"></i> -->
                <!--<h6 class="card-subtitle mb-2 text-body-secondary">
                    <span class="badge bg-danger" *ngIf="app.Production;else testApplicationTemplate">Production</span>
                </h6>
                <p class="card-text">
                    {{ app.Description }}
                </p>-->
                <div class="d-flex justify-content-center">
                    <a [href]="app.Url" class="btn btn-outline-primary text-nowrap me-2 stretched-link">
                        <i class="bi bi-box-arrow-in-up-right"></i>
                        Open app
                    </a>
                    <button class="btn btn-success " disabled *ngIf="app.Active;else inactiveApplicationTemplate">
                        <i class="bi bi-check-lg"></i> Active
                    </button>
                </div>
            </div>
        </div>
    </div>


    <ng-template #testApplicationTemplate>
        <span class="badge bg-success">Test</span>
    </ng-template>

    <ng-template #inactiveApplicationTemplate>
        <button class="btn btn-danger  me-2" disabled>
            <i class="bi bi-x-lg"></i>
            Inactive
        </button>
    </ng-template>
    <app-mercedes-loader *ngIf="Loading"></app-mercedes-loader>
</div>

